import { IAdvertising } from "api/types/_advertising";
import { IAgency } from "api/types/_agency";
import { ICoupang } from "api/types/_coupang";
import { IInventory, ITypeInventory } from "api/types/_inventory";
import { IMedia } from "api/types/_media";
import { Option } from "api/types/_public";
import { CONFIG_OPTION_TOAST_ERROR, CONFIG_OPTION_TOAST_NORMAL } from "common/toast";
import DatePickerCustom from "components/Common/DatePickerCustom";
import DropdownAgency from "components/Common/DropdownAgency";
import DropdownMedia from "components/Common/DropdownMedia";
import DropdownOption from "components/Common/DropdownOption";
import LabelWrapper from "components/Common/LabelWrapper";
import ModalConfirm from "components/Common/ModalConfirm";
import TableContainer from "components/Common/TableContainer";
import TooltipCustom from "components/Common/TooltipCustom";
import { useRole } from "components/Hooks/UserHooks";
import SVGImageDefault from "components/Images/SVGImageDefault";
import en from 'date-fns/locale/en-US';
import ko from 'date-fns/locale/ko';
import { AD_PLATFORM_INVENTORY_OPTIONS, AD_PLATFORM_INVENTORY_TYPE_COUPANG, AD_TYPE_INVENTORY_IS_FIXED_BANNER, AD_TYPE_INVENTORY_OPTIONS, POSITION_INVENTORY_OPTIONS } from "helpers/constans";
import { formatLinkHTTPS, formatNumberWithCommas } from "helpers/format";
import { isHavePermissionRole, ROLES_FOR_APP } from "helpers/role";
import moment from "moment";
import ConfigAgencyCPM from "pages/Managements/Inventory/ConfigAgencyCPM";
import ConfigInventoryCPM from "pages/Managements/Inventory/ConfigInventoryCPM";
import FormInventory from "pages/Managements/Inventory/FormInventory";
import InventoryHistory from "pages/Managements/Inventory/InventoryHistory";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import CountUp from "react-countup";
import { registerLocale } from "react-datepicker";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { Card, CardBody, CardHeader, Col, Container, Input, Modal, ModalBody, ModalHeader, Offcanvas, OffcanvasBody, OffcanvasHeader, Row, Spinner } from "reactstrap";
import { createSelector } from "reselect";
import { NumberParam, StringParam, useQueryParams, withDefault } from "use-query-params";
import BreadCrumb from "../../../components/Common/BreadCrumb";
import { deleteInventory, getAllAdvertising, getAllAgencies, getAllCoupangs, getAllDomains, getAllInventories, getAllMedias, getAllTypeInventories, reportInventories as onGetReportInVentories } from "../../../store/thunks";
import CopyWrapper from "components/Common/CopyWrapper";
import { IDomain } from "api/types/_domain";


const SORT_BY_DEFAULT = 'impression';
const ORDER_BY_DEFAULT = 'DESC';
const MAX_WIDTH_SCREEN = 1800;

registerLocale('en', en);
registerLocale('ko', ko);

const ReportInventory = () => {
    const { t, i18n } = useTranslation();
    const { userPermissions } = useRole();
    const navigate = useNavigate();

    const POSITION_INVENTORY_OPTIONS_LANG = POSITION_INVENTORY_OPTIONS?.map((item: any) => ({ value: item?.value, label: t(item?.label) }));
    const AD_PLATFORM_INVENTORY_OPTIONS_LANG = AD_PLATFORM_INVENTORY_OPTIONS?.map((item: any) => ({ value: item?.value, label: t(item?.label) }));
    const AD_TYPE_INVENTORY_OPTIONS_LANG = AD_TYPE_INVENTORY_OPTIONS?.map((item: any) => ({ value: item?.value, label: t(item?.label) }));

    const [query, setQuery]: any = useQueryParams({
        time_request: withDefault(NumberParam, 0),
        page: withDefault(NumberParam, 1),
        limit: withDefault(NumberParam, 100),
        sort_by: withDefault(StringParam, SORT_BY_DEFAULT),
        order_by: withDefault(StringParam, ORDER_BY_DEFAULT),
        media_id: withDefault(StringParam, ''),
        ad_platform: withDefault(StringParam, ''),
        ad_type: withDefault(StringParam, ''),
        agency_id: withDefault(StringParam, ''),
        tracking_code: withDefault(StringParam, ''),
        sub_id: withDefault(StringParam, ''),
        coupang_id: withDefault(StringParam, ''),
        inventory_type_id: withDefault(StringParam, AD_TYPE_INVENTORY_IS_FIXED_BANNER),
        start_date: withDefault(StringParam, `${moment().format("Y-MM-DD")}`),
        end_date: withDefault(StringParam, `${moment().format("Y-MM-DD")}`),
    });

    const dispatch: any = useDispatch();

    const selectLayoutState = (state: any) => state.Report;

    const ReportProperties = createSelector(
        selectLayoutState,
        (state) => ({
            inventories: state.inventories,
            isInventorySuccess: state.isInventorySuccess,
            isInventoryLoading: state.isInventoryLoading,
            error: state.error,
        })
    );

    const { inventories, isInventoryLoading } = useSelector(ReportProperties);
    const [isCallAllOptionLoading, setIsCallAllOptionLoading] = useState<boolean>(true);

    const [dateSearch, setDateSearch] = useState<any[]>([query?.start_date ? moment(query?.start_date, 'Y-MM-DD').toDate() : null, query?.end_date ? moment(query?.end_date || '', 'Y-MM-DD').toDate() : null]);
    const [startDate, endDate] = dateSearch;

    const [listDomain, setListDomain] = useState<IDomain[]>([]);

    const [listMedia, setListMedia] = useState<IMedia[]>([]);

    const [mediaSearch, setMediaSearch] = useState<Option | null>({
        label: listMedia?.filter((item) => String(item?.id || '') === String(query?.media_id || ''))[0]?.name || t('All Media'),
        value: `${listMedia?.filter((item) => String(item?.id || '') === String(query?.media_id || ''))[0]?.id || ''}`
    });

    const [listAgency, setListAgency] = useState<IAgency[]>([]);
    const [agencySearch, setAgencySearch] = useState<Option | null>({
        label: listAgency?.find((item) => String(item?.id || '') === String(query?.agency_id || ''))?.name || t('All Agency'),
        value: `${listAgency?.find((item) => String(item?.id || '') === String(query?.agency_id || ''))?.code || ''}`
    });

    const [listTypeInventory, setListTypeInventory] = useState<ITypeInventory[]>([]);
    const [typeInventorySearch, setTypeInventorySearch] = useState<Option | null>({
        label: listTypeInventory?.find((item) => String(item?.id || '') === String(query?.inventory_type_id || ''))?.title || t('All Type'),
        value: `${listTypeInventory?.find((item) => String(item?.id || '') === String(query?.inventory_type_id || ''))?.id || ''}`
    });

    const [listInventory, setListInventory] = useState<IInventory[]>([]);

    const [listAdvertising, setListAdvertising] = useState<IAdvertising[]>([]);

    const [listCoupang, setListCoupang] = useState<ICoupang[]>([]);

    const [coupangSearch, setCoupangSearch] = useState<Option | null>(null);

    const [adPlatformSearch, setAdPlatformSearch] = useState<Option | null>(AD_PLATFORM_INVENTORY_OPTIONS_LANG?.filter((item) => String(item?.value) === String(query?.ad_platform))[0]);

    const [adTypeSearch, setAdTypeSearch] = useState<Option | null>(AD_TYPE_INVENTORY_OPTIONS_LANG?.filter((item) => String(item?.value) === String(query?.ad_type))[0]);

    const [trackingCodeSearch, setTrackingCodeSearch] = useState<string>(query?.tracking_code || "");
    const [subIdSearch, setSubIdSearch] = useState<string>(query?.sub_id || "");

    const [inventoryDetail, setInventoryDetail] = useState<IInventory | null>(null);

    const [inventoryHistories, setInventoryHistories] = useState<IInventory | null>(null);

    const [idDelete, setIdDelete] = useState<number | null>(null);
    const [isConfirmLoading, setIsConfirmLoading] = useState<boolean>(false);

    const [inventoryShowCPM, setInventoryShowCPM] = useState<any>(null);

    const [windowSize, setWindowSize] = useState<{ width: number, height: number }>({ width: 0, height: 0 });

    useEffect(() => {
        dispatch(onGetReportInVentories(query));
    }, [JSON.stringify(query)]);

    const searchData = () => {
        setQuery({
            ...query,
            page: 1,
            start_date: startDate ? moment(new Date(startDate)).format("Y-MM-DD") : '',
            end_date: endDate ? moment(new Date(endDate)).format("Y-MM-DD") : '',
            // ad_platform: adPlatformSearch?.value || '',
            // ad_type: adTypeSearch?.value || '',
            media_id: mediaSearch?.value || '',
            // agency_id: agencySearch?.value || '',
            // inventory_type_id: typeInventorySearch?.value || '',
            // coupang_id: coupangSearch?.value || '',
            // tracking_code: trackingCodeSearch || '',
            // sub_id: subIdSearch || '',
            time_request: + new Date()
        });
    };

    const resetData = () => {
        const queryNew = {
            ...query,
            start_date: `${moment().format("Y-MM-DD")}`,
            end_date: `${moment().format("Y-MM-DD")}`,
            media_id: '',
            ad_platform: '',
            ad_type: '',
            agency_id: '',
            tracking_code: '',
            sub_id: '',
            coupang_id: '',
            inventory_type_id: AD_TYPE_INVENTORY_IS_FIXED_BANNER,
            sort_by: SORT_BY_DEFAULT,
            order_by: ORDER_BY_DEFAULT,
            time_request: + new Date(),
            page: 1,
        };
        setQuery(queryNew, "push");
        setDateSearch([moment(queryNew?.start_date || "", 'Y-MM-DD').toDate(), moment(queryNew?.end_date || "", 'Y-MM-DD').toDate()]);
        setMediaSearch({ label: t('All Media'), value: '' });
        setAgencySearch({ label: t('All Agency'), value: '' });
        setAdPlatformSearch(null);
        setAdTypeSearch(null);
        const type = listTypeInventory?.find((item: any) => String(item?.id || '') === String(queryNew?.inventory_type_id || '')) || null;
        setTypeInventorySearch((_prev) => ({ label: type?.title || t('All Type'), value: `${type?.id || ''}` }));
        setTrackingCodeSearch("");
        setSubIdSearch("");
        setCoupangSearch({ label: t('All'), value: '' });

    };

    // Column
    const columns = useMemo(
        () => [
            {
                Header: t('Ranking'),
                accessor: "rank",
                filterable: true,
                sortable: false,
                thWidth: 100,
                thClass: 'align-middle text-center',
                Cell: (cell: any) => {
                    return (
                        <div className="text-center" style={{ minWidth: '60px' }}>
                            <span>{cell?.value}</span>
                        </div>
                    )
                },
            },
            {
                Header: t('Media'),
                accessor: "media",
                filterable: true,
                sortable: false,
                thWidth: 220,
                thClass: 'align-middle',
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    const media = item?.media || null;
                    return (<>
                        {(!item?.text_row) && (<div className="d-flex align-items-center" style={{ minWidth: '200px' }}>
                            <div className="me-2">
                                {media?.logo_url ? (
                                    <img src={media?.logo_url || ''} alt={media?.name} className="avatar-sm object-fit-contain" style={{ backgroundColor: 'rgb(234 234 234 / 49%)', borderRadius: '5px' }} />) : (
                                    <SVGImageDefault style={{ height: '48px' }} />
                                )}
                            </div>
                            <div>
                                <div>
                                    {media?.name || ''}
                                </div>
                                <Link className='text-normal flex-shrink-0 ' to={formatLinkHTTPS(media?.website_link)} target="_blank">
                                    {media?.website || ''}
                                </Link>
                            </div>
                        </div>)}
                    </>)
                },
            },
            {
                Header: t('Inventory'),
                accessor: "inventory",
                filterable: false,
                sortable: false,
                thClass: 'align-middle',
                thWidth: 250,
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    const inventory = cell?.value;
                    const attributes = inventory?.attributes || null;
                    const position = POSITION_INVENTORY_OPTIONS_LANG?.find((p) => p?.value === attributes?.position) || null;
                    return (
                        <>
                            {!!item?.text_row ? <strong>{item?.text_row}</strong> : (
                                <div className="d-flex align-items-center position-relative" style={{ width: '230px' }}>
                                    <div className="flex-shrink-0 me-2 position-relative">
                                        <SVGImageDefault style={{ height: '48px' }} />
                                        {!!inventory?.parent_code ? <span className="position-absolute text-primary fs-14 text-uppercase" style={{ left: '50%', top: '50%', transform: 'translate(-50%, -50%)', width: '100%', textAlign: 'center' }}>{t('Sub')}</span> : <></>}
                                    </div>
                                    <div>
                                        <div className="ms-2">{inventory?.name || ''}</div>
                                        <div className="ms-2 fs-12 text-muted">{AD_PLATFORM_INVENTORY_OPTIONS_LANG?.find((op: any) => String(op?.value) === String(inventory?.ad_platform))?.label}</div>
                                        <strong className="text-muted ms-2">{attributes?.width || item?.width} * {attributes?.height || item?.height}</strong>
                                        {(String(inventory?.ad_type) === AD_TYPE_INVENTORY_IS_FIXED_BANNER) ? <></> : <TooltipCustom
                                            title={`(${t('Position')}, ${t('Margin Left')}, ${t('Margin Right')}, ${t('Margin Bottom')})`}
                                            className="d-inline-block vertical-align-middle"
                                        >
                                            <div className="ms-2 fs-12 text-muted">({position?.label || ''}, {String(attributes?.margin_left ?? '').replace(/px$/, '')}, {String(attributes?.margin_right ?? '').replace(/px$/, '')}, {String(attributes?.margin_bottom ?? '').replace(/px$/, '')})</div>
                                        </TooltipCustom>}
                                    </div>
                                    {isHavePermissionRole(ROLES_FOR_APP.INVENTORY_UPDATE, userPermissions) && (
                                        <Link className="btn btn-sm d-inline-block edit-item-btn position-absolute" to="#"
                                            style={{ right: '-10px', zIndex: 99 }}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                setInventoryDetail(item?.inventory);
                                            }}>
                                            <i className="ri-pencil-fill text-primary"></i>
                                        </Link>)}
                                </div>
                            )}
                        </>
                    )
                },
            },
            {
                Header: t('Ad Type'),
                accessor: "ad_type",
                filterable: false,
                sortable: false,
                thWidth: 130,
                thClass: 'text-center align-middle',
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (
                        <div className="text-center" style={{ minWidth: '100px' }}>
                            <span>{AD_TYPE_INVENTORY_OPTIONS_LANG?.find((i: any) => String(i?.value) === String(item?.inventory?.ad_type))?.label}</span>
                        </div>
                    )
                },
            },
            {
                Header: t('Impression'),
                accessor: "impression",
                filterable: false,
                sortable: true,
                thClass: 'align-middle text-end',
                thWidth: 150,
                thComponent: () => (
                    <div className="text-center d-inline-block">
                        {t('Impression')}
                        {/* <br />
                        <span className="fw-normal">({t('Coupang')})</span> */}
                    </div>
                ),
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (
                        <div style={{ minWidth: '150px' }}>
                            <div className="text-end pe-3" style={{ minWidth: '100px' }}>{formatNumberWithCommas(cell?.value)}</div>
                            {/* {!!item?.text_row && <div className="text-end pe-3" style={{ minWidth: '100px' }}>({formatNumberWithCommas(item?.impression_coupang)})</div>} */}
                        </div>
                    )
                },
            },
            {
                Header: t('Click'),
                accessor: "click",
                filterable: false,
                sortable: true,
                thClass: 'align-middle text-end',
                thWidth: 150,
                thComponent: () => (
                    <div className="text-center d-inline-block">
                        {t('Click')}
                        {/* <br />
                        <span className="fw-normal">({t('Coupang')})</span> */}
                    </div>
                ),
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (
                        <div style={{ minWidth: '150px' }}>
                            <div className="text-end pe-3" style={{ minWidth: '100px' }}>{formatNumberWithCommas(cell?.value)}</div>
                            {/* {!!item?.text_row && <div className="text-end pe-3" style={{ minWidth: '100px' }}>({formatNumberWithCommas(item?.click_coupang)})</div>} */}
                        </div>
                    )
                },
            },
            {
                Header: t('CTR'),
                accessor: "ctr",
                filterable: false,
                sortable: true,
                thClass: 'align-middle text-end',
                thWidth: 170,
                thComponent: () => (
                    <div className="text-center d-inline-block">
                        {t('CTR')}
                        {/* <br />
                        <span className="fw-normal">({t('Coupang')})</span> */}
                    </div>
                ),
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (
                        <div style={{ minWidth: '160px' }}>
                            <div className="text-end pe-3" style={{ minWidth: '100px' }}>{formatNumberWithCommas(cell?.value)} %</div>
                            {/* {!!item?.text_row && <div className="text-end pe-3" style={{ minWidth: '100px' }}>({formatNumberWithCommas(item?.ctr_coupang)} %)</div>} */}
                        </div>
                    )
                },
            },
            {
                Header: '',
                accessor: "__",
                filterable: false,
                sortable: false,
                thClass: 'align-middle text-start',
                thWidth: 20,
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (
                        <>

                        </>
                    )
                },
            },
            {
                Header: t('Coupang Name (Tracking Code)'),
                accessor: "coupang_name",
                filterable: false,
                sortable: false,
                thClass: 'align-middle text-start',
                thWidth: 210,
                Cell: (cell: any) => {
                    const item = cell?.row?.original?.inventory || null;
                    const _coupang_info = (item?.coupang_info || [])?.map((_cp: any) => {
                        const _coupang = listCoupang?.find((_c: any) => String(_c?.id || '') === String(_cp?.coupang_id || ''));
                        return ({ ..._cp, coupang_name: _coupang?.name })
                    });
                    return (
                        < div style={{ minWidth: '190px' }}>
                            {(`${item?.ad_platform}` === AD_PLATFORM_INVENTORY_TYPE_COUPANG) ? (_coupang_info || [])?.map((_info: any, _idx: number) => (
                                <div key={_idx} style={{ minHeight: '22px' }}>
                                    <CopyWrapper contentCopy={_info?.coupang_name} >
                                        {_info?.coupang_name || '-'}
                                        <TooltipCustom
                                            title={t('Total inventory used')}
                                            className="d-inline-block vertical-align-middle ms-1"
                                        >
                                            <span className="text-muted">({_info?.coupang_count || 0})</span>
                                        </TooltipCustom>
                                    </CopyWrapper>
                                </div>
                            )) : <CopyWrapper contentCopy={''}>
                                {'-'}
                            </CopyWrapper>}
                        </div>
                    )
                },
            },
            {
                Header: t('Tracking Code'),
                accessor: "tracking_code",
                filterable: false,
                sortable: false,
                thClass: 'align-middle text-start',
                thWidth: 170,
                Cell: (cell: any) => {
                    const item = cell?.row?.original?.inventory || null;
                    return (
                        <>
                            <div style={{ width: '150px' }} className="text-start">
                                {(`${item?.ad_platform}` === AD_PLATFORM_INVENTORY_TYPE_COUPANG) ? (item?.coupang_info || [])?.map((_info: any, _idx: number) => (
                                    <div key={_idx} style={{ minHeight: '22px' }}>
                                        <CopyWrapper contentCopy={_info?.ad_tracking_code} >
                                            {_info?.ad_tracking_code || '-'}
                                            <TooltipCustom
                                                title={t('Impression Ratio')}
                                                className="d-inline-block vertical-align-middle ms-1"
                                            >
                                                <span className="text-muted">{`(${Number(_info?.impression_ratio || (item?.coupang_info?.length === 1 ? 100 : 0))}%)`}</span>
                                            </TooltipCustom>
                                        </CopyWrapper>
                                    </div>
                                )) : <CopyWrapper contentCopy={item?.ad_tracking_code} >
                                    {item?.ad_tracking_code || '-'}
                                </CopyWrapper>}
                            </div>
                        </>
                    )
                },
            },
            {
                Header: t('Sub ID'),
                accessor: "sub_id",
                filterable: false,
                sortable: false,
                thClass: 'align-middle text-start',
                thWidth: 150,
                Cell: (cell: any) => {
                    const item = cell?.row?.original?.inventory || null;
                    return (
                        <>
                            <div style={{ width: '160px' }} className="text-start">
                                {(`${item?.ad_platform}` === AD_PLATFORM_INVENTORY_TYPE_COUPANG) ? (item?.coupang_info || [])?.map((_info: any, _idx: number) => (
                                    <div key={_idx} style={{ minHeight: '22px' }}>
                                        <CopyWrapper contentCopy={_info?.ad_sub_id} >
                                            {_info?.ad_sub_id || '-'}
                                        </CopyWrapper>
                                    </div>
                                )) : <CopyWrapper contentCopy={item?.ad_sub_id} >
                                    {item?.ad_sub_id || '-'}
                                </CopyWrapper>}
                            </div>
                        </>
                    )
                },
            },
            {
                Header: t('Action'),
                thWidth: 120,
                thClass: 'text-center align-middle',
                Cell: (cell: any) => {
                    const item: any = cell?.row?.original;
                    return (
                        <div className="text-center" style={{ width: '100px' }}>
                            {(!!item?.text_row) ? < div className="text-end">-</div> : <ul className="list-inline justify-content-end hstack gap-2 mb-0">
                                <TooltipCustom
                                    title={t('Button Detail Inventory')}
                                    id={`detail-cp-${item?.id}`}
                                >
                                    <li className="list-inline-item edit " title="Edit">
                                        <Link className="btn btn-sm btn-soft-secondary d-inline-block edit-item-btn" to="#"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                setInventoryDetail({ ...item?.inventory, is_preview: true });
                                            }}>
                                            <i className="ri-eye-fill"></i>
                                        </Link>
                                    </li>
                                </TooltipCustom>
                                {/* {isHavePermissionRole(ROLES_FOR_APP.INVENTORY_CONFIG_CPM, userPermissions) && (<TooltipCustom
                                    title={t('Button Config CPM')}
                                    id={`update-cp-${item?.id}`}
                                >
                                    <li className="list-inline-item edit " title="CPM">
                                        <Link className="btn btn-sm btn-soft-warning d-inline-block edit-item-btn" to="#"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                setInventoryShowCPM((_prev: any) => (item));
                                            }}>
                                            <i className="ri-shield-star-fill"></i>
                                        </Link>
                                    </li>
                                </TooltipCustom>)} */}
                                {isHavePermissionRole(ROLES_FOR_APP.INVENTORY_UPDATE, userPermissions) && (<TooltipCustom
                                    title={t('Button Update Inventory')}
                                    id={`update-cp-${item?.id}`}
                                >
                                    <li className="list-inline-item edit " title="Edit">
                                        <Link className="btn btn-sm btn-soft-primary d-inline-block edit-item-btn" to="#"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                setInventoryDetail(item?.inventory);
                                            }}>
                                            <i className="ri-pencil-fill"></i>
                                        </Link>
                                    </li>
                                </TooltipCustom>)}
                                {/* {isHavePermissionRole(ROLES_FOR_APP.INVENTORY_UPDATE, userPermissions) && (<TooltipCustom
                                    title={t('Button Ad Information History')}
                                    id={`update-cp-${item?.id}`}
                                >
                                    <li className="list-inline-item edit " title="Edit">
                                        <Link className="btn btn-sm btn-soft-warning d-inline-block edit-item-btn" to="#"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                setInventoryHistories(item?.inventory);
                                            }}>
                                            <i className=" ri-time-line"></i>
                                        </Link>
                                    </li>
                                </TooltipCustom>)} */}
                                {isHavePermissionRole(ROLES_FOR_APP.INVENTORY_DELETE, userPermissions) && (<TooltipCustom
                                    title={t('Button Delete Inventory')}
                                    id={`detail-cp-${item?.id}`}
                                >
                                    <li className="list-inline-item" title="Remove">
                                        <Link className="btn btn-sm btn-soft-danger d-inline-block edit-item-btn" to="#"
                                            onClick={(e) => { e.preventDefault(); handleConfirmDelete(item?.inventory) }}
                                        >
                                            <i className="ri-delete-bin-5-fill"></i>
                                        </Link>
                                    </li>
                                </TooltipCustom>)}
                            </ul>}
                        </div>
                    );
                },
            }
        ],
        [i18n?.language, userPermissions, listCoupang]
    );

    const handleChangePage = useCallback((page: any) => {
        setQuery({ page: page + 1 })
    }, []);

    const handleChangeSorting = useCallback((sortBy: any) => {
        setQuery((_prev: any) => {
            return ({ ..._prev, ...sortBy });
        });
    }, []);

    const handleChangePicker = (values: any[] = []) => {
        setDateSearch((_prev: any) => values);
    };

    const handleActionRefresh = () => {
        dispatch(onGetReportInVentories(query));
    };

    const handleRefresh = () => {
        try {
            // setIsShowModalAssignAutomaticRedirect((_prev) => false);
            setInventoryDetail((_prev) => null);
            setQuery({ ...query, time_request: + new Date() }, "push");
            handleRefreshAllInventories();
            handleRefreshAllCoupangs();
        } catch (error: any) {
            return error;
        }
    }

    const handleRefreshAllCoupangs = async () => {
        try {
            const [resCoupang]: any = await Promise.all([getAllCoupangs()]);
            const list_c = (resCoupang?.data || []);
            setListCoupang((_prev) => list_c);
        } catch (error: any) {
            return error;
        }
    }

    const handleRefreshAllInventories = async () => {
        try {
            const [resInventory]: any = await Promise.all([getAllInventories()]);
            const list_i = (resInventory?.data || []);
            setListInventory((_prev) => list_i);
        } catch (error: any) {
            return error;
        }
    }

    // Begin::Delete
    const handleConfirmDelete = (item: IInventory) => {
        setIdDelete((_prev) => item?.id);
    };

    const handleActionDelete = async () => {
        if (!idDelete) { return; };
        try {
            setIsConfirmLoading((_prev) => true);
            const response: any = await deleteInventory(idDelete);
            if (response?.code === 200) {
                dispatch(onGetReportInVentories(query));
                setIsConfirmLoading((_prev) => false);
                setIdDelete((_prev) => null);
                toast(`${t('The process has been completed.')}`, CONFIG_OPTION_TOAST_NORMAL);
                handleRefreshAllInventories();
            } else {
                setIsConfirmLoading((_prev) => false);
                toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
            }
        } catch (error: any) {
            setIsConfirmLoading((_prev) => false);
            toast(`${error?.message || ''}`, CONFIG_OPTION_TOAST_ERROR);
            return error;
        }
    };

    const onCloseConfirmClick = () => {
        setIdDelete((_prev) => null);
    }
    // End::Delete

    useEffect(() => {
        const handleCallAllOption = async () => {
            try {
                setIsCallAllOptionLoading((_prev) => true);
                const [resMedia, resAgency, resInventory, resTypeInventory, resCoupang, resAdvertising, resDomain]: any = await Promise.all([getAllMedias(), null, getAllInventories(), getAllTypeInventories(), getAllCoupangs(), null, null]);
                setIsCallAllOptionLoading((_prev) => false);

                const list_m = ([{ name: t('All Media'), id: '', website: '' } as any]).concat(resMedia?.data || []);
                const media = list_m?.find((item) => String(item?.id || '') === String(query?.media_id || '')) || null;
                setListMedia((_prev) => list_m);
                setMediaSearch((_prev) => ({
                    label: media?.name || t('All Media'),
                    value: `${media?.id || ''}`
                }));

                const list_a = ([{ name: t('All Agency'), id: '', code: '' } as any]).concat(resAgency?.data || []);
                const agency = list_a?.find((item) => String(item?.id || '') === String(query?.agency_id || '')) || null;
                setListAgency((_prev) => list_a);
                setAgencySearch((_prev) => ({
                    label: agency?.name || t('All Agency'),
                    value: `${agency?.id || ''}`
                }));

                const list_t = resTypeInventory?.data || [];
                const type = list_t?.find((item: any) => String(item?.id || '') === String(query?.inventory_type_id || '')) || null;
                setListTypeInventory((_prev) => list_t);
                setTypeInventorySearch((_prev) => ({
                    label: type?.title || t('All Type'),
                    value: `${type?.id || ''}`,
                }));

                const list_coupang = (resCoupang?.data || []);
                const coupang = list_coupang?.find((item: any) => String(item?.id || '') === String(query?.coupang_id || '')) || null;
                setListCoupang((_prev) => list_coupang);
                setCoupangSearch((_prev) => ({
                    label: coupang?.name || t('All'),
                    value: `${coupang?.id || ''}`,
                }));

                const list_i = (resInventory?.data || []);
                setListInventory((_prev) => list_i);

                const list_ad = (resAdvertising?.data || []);
                setListAdvertising((_prev) => list_ad);

                const list_d = resDomain?.data || [];
                setListDomain((_prev) => list_d);

            } catch (error: any) {
                setIsCallAllOptionLoading((_prev) => false);
                return error;
            }
        };
        handleCallAllOption();
    }, []);

    useEffect(() => {
        if (mediaSearch) {
            setListMedia((_prev) => (_prev || [])?.map((item) => item?.id ? item : ({ ...item, name: t('All Media') })));
            (!mediaSearch?.value) && setMediaSearch((prev) => ({ label: t('All Media'), value: '' }));
        }
        if (agencySearch) {
            setListAgency((_prev) => (_prev || [])?.map((item) => item?.id ? item : ({ ...item, name: t('All Agency') })));
            (!agencySearch?.value) && setAgencySearch((prev) => ({ label: t('All Agency'), value: '' }));
        }
        if (adPlatformSearch) {
            setAdPlatformSearch((_prev: any) =>
                AD_PLATFORM_INVENTORY_OPTIONS_LANG?.filter((e: any) => e.value === adPlatformSearch?.value)[0]
            );
        }
        if (adTypeSearch) {
            setAdTypeSearch((_prev: any) =>
                AD_TYPE_INVENTORY_OPTIONS_LANG?.filter((e: any) => e.value === adTypeSearch?.value)[0]
            );
        }

        document.title = `${t("Report Inventory")} - ${t("Reports")} | AdsHub`;
        document.body.classList.remove("vertical-sidebar-enable");
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [i18n?.language]);


    useEffect(() => {
        function handleResize() {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        }
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title={t('Report Inventory')} pageTitle={t('Reports')} />
                    {isHavePermissionRole(ROLES_FOR_APP.REPORT_INVENTORY, userPermissions) && (
                        <Row>
                            <Col sm={12} md={12}>
                                <Card id="customerList" style={{ boxShadow: '0px 3px 4px 0px rgba(0, 0, 0, 0.03)' }} className="ribbon-box right">
                                    <div className="ribbon round-shape" style={{ background: 'rgb(40 99 213)', fontWeight: 300, fontSize: '0.8rem', top: '11px' }}>{t('This data is analyzed per 10 mins')}</div>
                                    <CardHeader className="border-0" style={{ borderRadius: '30px' }}>
                                        <Row className="g-4 align-items-center">
                                            <div className="col-sm">
                                                <div>
                                                    <h5 className="card-title mb-0">
                                                        <span className="me-2">{t('Total')}:</span>
                                                        <CountUp
                                                            start={0}
                                                            end={inventories?.pagination?.total || 0}
                                                            duration={1}
                                                            className="text-primary"
                                                        />
                                                    </h5>
                                                </div>
                                            </div>
                                        </Row>
                                    </CardHeader>
                                    <div className=" border border-dashed border-end-0 border-start-0 card-body mt-0 pb-4">
                                        <Row className="g-4 align-items-center mt-0">
                                            {/* <Col sm={12} md={6} xl={3} xxl={3} className='mt-3 mt-xl-2'>
                                                <LabelWrapper label={t('Ad Platform')} isShow={true}>
                                                    <DropdownOption
                                                        name=""
                                                        dataList={AD_PLATFORM_INVENTORY_OPTIONS_LANG}
                                                        placeholder={`${t("Ad Platform")}...`}
                                                        className="search-filter-category-type dropdown-status-rounded"
                                                        classNamePrefix="name-prefix"
                                                        initialValue={adPlatformSearch || null}
                                                        onChangeSelect={(e: any) => setAdPlatformSearch(e)}
                                                        isHasOptionAll={true}
                                                        optionAll={{ label: t('All Ad Platform'), value: '' }}
                                                    />
                                                </LabelWrapper>
                                            </Col>
                                            <Col sm={12} md={6} xl={3} xxl={3} className='mt-3 mt-xl-2'>
                                                <LabelWrapper label={t('Inventory Type Of Inventory In Filter')} isShow={true}>
                                                    <DropdownOption
                                                        name="inventory_type"
                                                        dataList={listTypeInventory?.map((item) => ({ value: String(item?.id), label: item?.title }))}
                                                        placeholder={`${t('Inventory Type Of Inventory In Filter')}...`}
                                                        className="search-filter-category-type dropdown-status-rounded"
                                                        classNamePrefix="name-prefix"
                                                        initialValue={typeInventorySearch || null}
                                                        onChangeSelect={(e: any) => setTypeInventorySearch(e)}
                                                        isHasOptionAll={true}
                                                        optionAll={{ label: t('All Type'), value: '' }}
                                                    />
                                                </LabelWrapper>
                                            </Col>
                                            <Col sm={12} md={6} xl={3} xxl={3} className='mt-3 mt-xl-2'>
                                                <LabelWrapper label={t('Ad Type')} isShow={true}>
                                                    <DropdownOption
                                                        name="ad_type"
                                                        dataList={AD_TYPE_INVENTORY_OPTIONS_LANG}
                                                        placeholder={`${t('Ad Type')}...`}
                                                        className="search-filter-category-type dropdown-status-rounded"
                                                        classNamePrefix="name-prefix"
                                                        initialValue={adTypeSearch || null}
                                                        onChangeSelect={(e: any) => setAdTypeSearch(e)}
                                                        isHasOptionAll={true}
                                                        optionAll={{ label: t('All Type'), value: '' }}
                                                    />
                                                </LabelWrapper>
                                            </Col> */}
                                            <Col sm={12} md={6} xl={3} xxl={3} className='mt-3 mt-xl-2'>
                                                <LabelWrapper label={t('Media')} isShow={!!mediaSearch?.value}>
                                                    <DropdownMedia
                                                        name="medias"
                                                        dataList={listMedia}
                                                        initialValue={mediaSearch}
                                                        onChangeSelect={(event: any) => {
                                                            setMediaSearch((_prev) => event);
                                                        }}
                                                    />
                                                </LabelWrapper>
                                            </Col>
                                            <Col sm={12} md={6} xl={3} xxl={3} className='date-picker-wrapper-custom mt-3 mt-xl-2'>
                                                <LabelWrapper label={t('Date')} isShow={!!startDate || !!endDate}>
                                                    <DatePickerCustom
                                                        placeholder={`${t('Start Date')} - ${t('End Date')}`}
                                                        startDate={startDate || null}
                                                        endDate={endDate || null}
                                                        onChangePicker={handleChangePicker}
                                                        showOptions={[
                                                            'today', 'yesterday', 'two_day_ago',
                                                            'last_3_days', 'last_7_days', 'last_14_days', 'last_30_days',
                                                            'this_week', 'last_week',
                                                            'this_month', 'last_month',
                                                        ]}
                                                    />
                                                </LabelWrapper>
                                            </Col>

                                            {/* <Col sm={12} md={6} xl={3} xxl={3} className='mt-3'>
                                                <LabelWrapper label={t('Agency')} isShow={!!agencySearch?.value}>
                                                    <DropdownAgency
                                                        name="agency"
                                                        typeValue="id"
                                                        dataList={listAgency}
                                                        initialValue={agencySearch}
                                                        onChangeSelect={(event: any) => {
                                                            setAgencySearch((_prev) => event);
                                                        }}
                                                    />
                                                </LabelWrapper>
                                            </Col> */}

                                            {/* <Col sm={12} md={6} xl={3} xxl={3} className='mt-3'>
                                                <LabelWrapper label={t('Coupang Name (Tracking Code)')} isShow={true}>
                                                    <DropdownOption
                                                        name="coupang_id"
                                                        dataList={listCoupang?.map((item) => ({ value: String(item?.id), label: item?.name }))}
                                                        placeholder={`${t('Coupang Name (Tracking Code)')}...`}
                                                        className="search-filter-category-type dropdown-status-rounded"
                                                        classNamePrefix="name-prefix"
                                                        initialValue={coupangSearch || null}
                                                        onChangeSelect={(e: any) => setCoupangSearch(e)}
                                                        isHasOptionAll={true}
                                                        optionAll={{ label: t('All'), value: '' }}
                                                    />
                                                </LabelWrapper>
                                            </Col>
                                            <Col sm={12} md={6} xl={3} xxl={3} className='mt-3'>
                                                <LabelWrapper label={t('Tracking Code')} isShow={!!trackingCodeSearch}>
                                                    <Input
                                                        type="text"
                                                        className="form-control search"
                                                        placeholder={`${t('Tracking Code')}...`}
                                                        value={trackingCodeSearch}
                                                        onChange={(e) => setTrackingCodeSearch(e.target.value)}
                                                        onKeyDown={(e) => {
                                                            if (e.key === "Enter") {
                                                                searchData();
                                                            }
                                                        }}
                                                    />
                                                </LabelWrapper>
                                            </Col>
                                            <Col sm={12} md={6} xl={3} xxl={3} className='mt-3'>
                                                <LabelWrapper label={t('Sub ID')} isShow={!!subIdSearch}>
                                                    <Input
                                                        type="text"
                                                        className="form-control search"
                                                        placeholder={`${t('Sub ID')}...`}
                                                        value={subIdSearch}
                                                        onChange={(e) => setSubIdSearch(e.target.value)}
                                                        onKeyDown={(e) => {
                                                            if (e.key === "Enter") {
                                                                searchData();
                                                            }
                                                        }}
                                                    />
                                                </LabelWrapper>
                                            </Col> */}
                                            <Col sm={12} md={12} xl={6} xxl={6} className="hstack gap-1 justify-content-center justify-content-sm-end justify-content-xl-start mt-3 mt-xl-2">
                                                <div>
                                                    <button
                                                        type="button"
                                                        className="btn btn-primary me-2 "
                                                        onClick={searchData}
                                                        disabled={(isInventoryLoading || isCallAllOptionLoading)}
                                                    >
                                                        {(isInventoryLoading || isCallAllOptionLoading) ? <div className="me-1" style={{ display: 'inline-table', verticalAlign: 'top' }}><Spinner size="sm" style={{ width: '14px', height: '14px' }}></Spinner></div> : <i className="ri-search-line align-bottom me-1"></i>}{" "}
                                                        {t('Button Search')}
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="btn btn-secondary fs-14"
                                                        onClick={resetData}
                                                    >
                                                        <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                                                        {t('Button Reset')}
                                                    </button>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                    <CardBody className="pt-3">
                                        <TableContainer
                                            className="custom-header-css"
                                            divClass="table-responsive table-card"
                                            tableClass="align-middle table-bordered-dashed table-have-first-row-is-total sticky-table-report-inventory"
                                            theadClass="table-light text-muted"
                                            columns={columns}
                                            data={inventories?.list?.length ? (
                                                [
                                                    {
                                                        ...inventories?.total,
                                                        impression_coupang: inventories?.coupang?.impression,
                                                        click_coupang: inventories?.coupang?.click,
                                                        commission_coupang: inventories?.coupang?.commission,
                                                        ctr_coupang: inventories?.coupang?.ctr,
                                                        domain: null,
                                                        text_row: t('Sum')
                                                    },
                                                    ...inventories?.list]
                                            ) : []}
                                            customPageSize={query.limit}
                                            customPageIndex={query.page - 1}
                                            totalRecords={inventories?.pagination?.total}
                                            customPageCount={Math.ceil(Number(inventories?.pagination?.total) / Number(inventories?.pagination?.limit))}
                                            handleChangePage={handleChangePage}
                                            manualSorting={true}
                                            sorting={{ sort_by: query.sort_by, order_by: query.order_by }}
                                            handleChangeSorting={handleChangeSorting}
                                            isLoading={isInventoryLoading}
                                        />
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    )}


                    {(windowSize?.width >= MAX_WIDTH_SCREEN) && (
                        <Offcanvas
                            fade
                            scrollable={false}
                            direction="end"
                            isOpen={(inventoryDetail !== null)}
                            id="offcanvasExample"
                            className='off-canvas-lg off-canvas-lg-600'
                        >
                            <OffcanvasHeader className="bg-light" toggle={() => setInventoryDetail((_prev) => null)}>
                                <h5 className="fs-16 mb-1">{!!inventoryDetail?.id ? (inventoryDetail?.is_preview ? t('Button Detail Inventory') : t('Button Update Inventory')) : t('Button Create Inventory')}</h5>
                            </OffcanvasHeader>
                            <OffcanvasBody className="color-scrollbar-os">
                                <FormInventory medias={listMedia} agencies={(listAgency || [])?.filter((item) => !!item?.id)} coupangs={listCoupang} inventories={listInventory} advertising={listAdvertising} domains={listDomain} types={listTypeInventory} detail={inventoryDetail} triggerRefresh={handleRefresh} handleClose={() => setInventoryDetail((_prev) => null)} />
                            </OffcanvasBody>
                        </Offcanvas>
                    )}

                    {(windowSize?.width < MAX_WIDTH_SCREEN) && (<Modal
                        isOpen={inventoryDetail !== null}
                        centered={true}
                        size="md"
                        toggle={() => setInventoryDetail((_prev) => null)}
                        keyboard={true}
                    >
                        <ModalHeader toggle={() => setInventoryDetail((_prev) => null)}>
                            {!!inventoryDetail?.id ? (inventoryDetail?.is_preview ? t('Button Detail Inventory') : t('Button Update Inventory')) : t('Button Create Inventory')}
                        </ModalHeader>
                        <ModalBody className="">
                            <FormInventory medias={listMedia} agencies={(listAgency || [])?.filter((item) => !!item?.id)} coupangs={listCoupang} inventories={listInventory} advertising={listAdvertising} domains={listDomain} types={listTypeInventory} detail={inventoryDetail} triggerRefresh={handleRefresh} handleClose={() => setInventoryDetail((_prev) => null)} />
                        </ModalBody>
                    </Modal>)}

                    <Modal
                        isOpen={inventoryHistories !== null}
                        centered={true}
                        size="lg"
                        toggle={() => setInventoryHistories((_prev) => null)}
                        keyboard={true}
                    >
                        <ModalHeader toggle={() => setInventoryHistories((_prev) => null)}>
                            {t('Button Ad Information History')}
                        </ModalHeader>
                        <ModalBody className="">
                            <Col md={12} lg={12}>
                                <InventoryHistory inventoryId={inventoryHistories?.id} />
                            </Col>
                            <Col lg={12}>
                                <div className="hstack gap-2 justify-content-sm-center justify-content-md-end mt-3">
                                    <button
                                        className="btn btn-soft-secondary rounded-pill fs-14 me-2"
                                        color="light"
                                        type="button"
                                        style={{ width: '100px' }}
                                        onClick={() => setInventoryHistories((_prev) => null)}
                                    >
                                        {t("Button Close")}
                                    </button>
                                </div>
                            </Col>
                        </ModalBody>
                    </Modal>


                    <Modal isOpen={!!inventoryShowCPM} centered={true} scrollable={true} size="xl modal-xxll">
                        <ModalHeader toggle={() => setInventoryShowCPM((prev: any) => (prev ? null : prev))}>
                            {t('Button Config CPM')}
                        </ModalHeader>
                        <ModalBody className="py-3 pt-0 px-4">
                            <div style={{ minHeight: '450px' }}>
                                <Row>
                                    <Col md={12} lg={6}>
                                        <ConfigInventoryCPM
                                            inventoryId={inventoryShowCPM?.inventory?.id}
                                            inventory={inventoryShowCPM?.inventory}
                                            handleActionRefresh={handleActionRefresh}
                                            handleCloseModal={() => setInventoryShowCPM((prev: any) => (null))}
                                        />
                                    </Col>
                                    <Col md={12} lg={6}>
                                        <ConfigAgencyCPM
                                            inventoryId={inventoryShowCPM?.inventory?.id}
                                            agencyCode={inventoryShowCPM?.inventoryAgency?.agency_code}
                                            inventory={inventoryShowCPM}
                                            handleActionRefresh={handleActionRefresh}
                                            handleCloseModal={() => setInventoryShowCPM((prev: any) => (null))}
                                        />
                                    </Col>
                                </Row>
                            </div>
                        </ModalBody>
                    </Modal>

                    <ModalConfirm
                        header={t('Button Delete Inventory')}
                        isOpen={idDelete !== null}
                        isLoading={isConfirmLoading}
                        onClose={onCloseConfirmClick}
                        onConfirm={handleActionDelete}
                    />
                    <ToastContainer closeButton={false} limit={1} />
                </Container>
            </div>
        </React.Fragment>
    );
};

export default ReportInventory;
